module.exports = __webpack_public_path__ + "static/media/DSC00143-3.f19a1e84.jpg";